import {StyleSheet} from '@react-pdf/renderer';

export const cultureFitStyles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '16px',
  },
});
